export enum BnplPlanStepEnum {
  PlanAmount = 0,
  PreInstallmentAmount = 1,
  InstallmentCount = 2,
  ProfitPercent = 3,
  PlanContract = 4,
  SalaryDeduction = 5,
}
